module.exports = __webpack_public_path__ + "img/vote-6.f7c3c58f.png";